import { render, staticRenderFns } from "./update-product-pricing.vue?vue&type=template&id=24e681c3&"
import script from "./update-product-pricing.vue?vue&type=script&lang=ts&"
export * from "./update-product-pricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports